import { Icon, IconProps } from '~/components/Icon/Icon';

export const PlusIcon = (props: IconProps) => (
  <Icon
    width="18"
    height="19"
    viewBox="0 0 18 19"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.5 2C10.5 1.17157 9.82843 0.5 9 0.5C8.17157 0.5 7.5 1.17157 7.5 2L7.5 8H1.5C0.671573 8 0 8.67157 0 9.5C0 10.3284 0.671573 11 1.5 11H7.5L7.5 17C7.5 17.8284 8.17157 18.5 9 18.5C9.82843 18.5 10.5 17.8284 10.5 17V11H16.5C17.3284 11 18 10.3284 18 9.5C18 8.67157 17.3284 8 16.5 8H10.5V2Z"
      fill="#D9D9D9"
    />
  </Icon>
);
